import PerformanceTrend from "./PerformanceTrend.component";

export default PerformanceTrend;
